import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import locales from '../locales';

const { defaultLanguage } = locales;
const languages = _.map(locales.languages, language => language.key);

const initialActions = {};

export default (mapStateToProps, actions = {}) => Component => {
  const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({ ...initialActions, ...actions }, dispatch)
  });
  @connect(
    mapStateToProps,
    mapDispatchToProps
  )
  class WithRedux extends React.PureComponent {
    getLangData = language => {
      const langData = _.get(_.find(locales.languages, { key: language }), 'data');
      return langData;
    };
    getAnyLanguage = content => {
      let result = content;
      for (let index = 0; index < languages.length; index += 1) {
        const language = languages[index];
        const langData = this.getLangData(language);
        const contentLang = _.get(langData, content);
        if (contentLang) {
          result = contentLang;
          break;
        }
      }
      return result;
    };
    getDefaultLanguage = content => {
      const langData = this.getLangData(defaultLanguage);
      const contentLang = _.get(langData, content);
      if (!contentLang) return this.getAnyLanguage(content);
      return contentLang;
    };
    getDataFromObject = object => {
      const { currentActive } = this.props.languages;
      let string = _.get(object, currentActive, _.get(object, defaultLanguage));
      if (!string) string = object[Object.keys(object)[0]];
      return string;
    };
    getDataFromString = content => {
      const { currentActive } = this.props.languages;
      const langData = this.getLangData(currentActive);
      const contentLang = _.get(langData, content);
      if (!contentLang) return this.getDefaultLanguage(content);
      return contentLang;
    };
    getDataWithLanguage = content => {
      let result = content;
      result = _.isObject(content) ? this.getDataFromObject(content) : this.getDataFromString(content);
      return result;
    };
    render() {
      return <Component {...this.props} t={this.getDataWithLanguage} />;
    }
  }

  return WithRedux;
};



// WEBPACK FOOTER //
// ./src/hoc/withRedux.js